import React from 'react'
import { Grid, Paper, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    cellOverlapShiftContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%", 
        width: "100%",
        padding: 0,
        borderTop: "0.2px solid #f5f0f0",
        borderBottom: 'none'
    },
    shiftStart: {
        color: "white",
        fontSize: 12,
        padding: 5,
        paddingRight: 0,
        margin: 0,
        width: "50%",
        textAlign: "right",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        display: "flex", 
        alignItems: "center",
        justifyContent: "center",
        gap: "4px"
    },
}));

export const FinalCell = ({ id, color, name }) => {
    const classes = useStyles();
    return (
        <Grid item xs key={id} style={{ flexGrow: 1, display:'flex', justifyContent:'flex-end'}}>
            <div className={classes.cellOverlapShiftContainer}
                style={{
                    borderTop: "0.2px solid #f5f0f0",
                    borderRight: "0.2px solid #f5f0f0"
                }}
            >
                <Paper
                    className={classes.shiftStart}
                    style={{ backgroundColor: color, color: color === '#ffffff' ? "black" : "white", }}
                >
                    {name}
                </Paper>
            </div>
        </Grid>
    )
}